import React from 'react';
import { func, number, oneOf } from 'prop-types';

// Components
import { Box, Button, useTheme } from '@mui/material';
import { DragIndicatorOutlined } from '@mui/icons-material';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';

const DragAndDropButtonGroup = ({ idx, onRemoveSeq, mode, onAddSeq }) => {
  const { palette } = useTheme();

  const sxStyles = {
    buttonLabel: {
      fontSize: 24,
      height: '100%',
      margin: 'auto',
      textAlign: 'center',
    },
    iconContainer: {
      ':disabled': {
        border: `1px solid ${palette.text.disabled}`,
      },
      borderRadius: 0.5,
      boxShadow: 'none',
      margin: 0,
      minWidth: 24,
      padding: 0,
      width: 24,
    },
  };
  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        gap: 0.5,
        justifyContent: 'flex-end',
      }}
    >
      <DragIndicatorOutlined
        data-testid="DragIndicatorIcon"
        sx={sxStyles.iconContainer}
        variant="buttonsDragHandle"
      />
      {mode === 'add' ? (
        <Button
          aria-label="Add to sequence"
          height="24px"
          onClick={() => {
            onAddSeq(idx);
          }}
          sx={{
            ...sxStyles.iconContainer,
          }}
          variant="_next.text"
        >
          <AddIcon sx={sxStyles.buttonLabel} variant="buttonsDragButtons" />
        </Button>
      ) : (
        <Button
          aria-label="Remove sequence"
          height="24px"
          onClick={() => {
            onRemoveSeq(idx);
          }}
          sx={{
            ...sxStyles.iconContainer,
          }}
          variant="_next.text"
        >
          <RemoveIcon sx={sxStyles.buttonLabel} variant="buttonsDragButtons" />
        </Button>
      )}
    </Box>
  );
};

export default DragAndDropButtonGroup;

DragAndDropButtonGroup.propTypes = {
  idx: number.isRequired,
  mode: oneOf(['add', 'remove']),
  onAddSeq: func,
  onRemoveSeq: func,
};

DragAndDropButtonGroup.defaultProps = {
  mode: 'remove',
  onAddSeq: () => {},
  onRemoveSeq: () => {},
};
